"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoreSnackbar = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = require("prop-types");

var _useOutsideClick = require("../../helpers/useOutsideClick");

var _classnames = _interopRequireDefault(require("classnames"));

var _SvgIconInfo = require("../svg/feathers/SvgIconInfo");

var _SvgIconAlertTriangle = require("../svg/feathers/SvgIconAlertTriangle");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CoreSnackbar = function CoreSnackbar(props) {
  var messages = props.messages,
      onCloseEnd = props.onCloseEnd,
      cn = props.cn,
      portalTarget = props.portalTarget,
      nodeClose = props.nodeClose,
      buttons = props.buttons;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      activeMessage = _useState2[0],
      setActiveMessage = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var element = (0, _react.useRef)(null);
  var closeHandler = (0, _react.useCallback)(function () {
    return setOpen(false);
  }, []);
  var outsideClickHandler = (0, _react.useMemo)(function () {
    return (0, _useOutsideClick.getOutsideClickHandler)(element, closeHandler);
  }, [closeHandler]);
  var onTransitionEndHandler = (0, _react.useCallback)(function () {
    if (open) return;
    setActiveMessage(null);
    onCloseEnd({
      message: messages[0],
      index: 0
    });
  }, [messages, onCloseEnd, open]);
  (0, _react.useEffect)(function () {
    if (!messages.length || activeMessage) return;
    setActiveMessage(messages[0]);
    setOpen(true);
  }, [activeMessage, messages]);
  (0, _useOutsideClick.useOutsideClick)(outsideClickHandler, open);
  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[activeMessage && activeMessage.view ? activeMessage.view : 'usual'], (0, _defineProperty2.default)({}, cn.open, open)),
    ref: element,
    onTransitionEnd: onTransitionEndHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.content
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.icon
  }, activeMessage && activeMessage.view === 'usual' ? /*#__PURE__*/_react.default.createElement(_SvgIconInfo.SvgIconInfo, null) : /*#__PURE__*/_react.default.createElement(_SvgIconAlertTriangle.SvgIconAlertTriangle, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.message
  }, activeMessage ? activeMessage.message : ''), !buttons ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.buttons
  }, buttons), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.close,
    onClick: closeHandler
  }, nodeClose))), portalTarget);
};

exports.CoreSnackbar = CoreSnackbar;
CoreSnackbar.propTypes = {
  /* component logic props */
  messages: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    message: _propTypes.node.isRequired,
    view: _propTypes.string
  })).isRequired,
  onCloseEnd: _propTypes.func.isRequired,
  portalTarget: (0, _propTypes.oneOfType)([(0, _propTypes.instanceOf)(Element), (0, _propTypes.instanceOf)(HTMLDocument)]),
  nodeClose: _propTypes.node.isRequired,
  buttons: _propTypes.node,

  /* binded classes */
  cn: _propTypes.object.isRequired
};
CoreSnackbar.defaultProps = {
  portalTarget: document.body,
  buttons: null
};